<template>
  <!-- Loading State -->
  <div>
    <agency-need-auth-details-vue v-if="Iftoken"/>
    <agency-need-un-auth-details-vue  v-if="!Iftoken"/>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AgencyNeedAuthDetailsVue from "./AgencyNeedAuthDetails.vue";
import AgencyNeedUnAuthDetailsVue from "./AgencyNeedUnAuthDetails.vue";

export default {
  components: {
    AgencyNeedAuthDetailsVue,
    AgencyNeedUnAuthDetailsVue,
  },
  data() {
    return {
      loading: false,
      token: null,
      Iftoken:false,
    };
  },
  computed: {
    ...mapGetters({
      profile: "auth/getProfile",
      profileType: "auth/getType",
      timezone: "usersetting/getTimeZone",
    }),
  },
  methods: {
    fetchToken() {
      this.token = localStorage.getItem("user-token");
      if (this.token) {
        this.Iftoken = true;
      } else {
        this.Iftoken = false;
      }
    },
  },
  created() {
    this.fetchToken();
  },
};
</script>